<template>
    <div class="option-slide-container" :class="{'disabled-input' : disabled }">
        <h3 class="label-carousel" :class="{'no-sel-active' : noSelActive}"> {{ label }} </h3>
        <div v-if="showControls" class="controls-container">
            <div class="control-prev"
                :class="{'expanded' : isFirstSelected}"
                @click="controlDir(-1)"
            >
                <i class="prz-chevron-left"/>
            </div>
            <div class="control-next"
                :class="{'expanded' : isLastSelected}"
                @click="controlDir(1)"
            >
                <i class="prz-chevron-right"/>
            </div>
        </div>
        <div class="vue-cart-type-carousel" :class="{ 'single-item' : options.length == 1, 'scroll-safari' : isSafari }" :id="id" ref="carouselPicker">
            <div
                class="snap-slider-item"
                v-for="(option, index) in options"
                :key="option.id"
                :class="{'option-active': value && option.id === value.id}"
                :data-id="option.id"
                :data-order="index"
                :data-isdefaultsku="option.default"
                @click="updateOption(option, true)"
                ref="carouselItems"
            >
                <img
                    itemprop="image"
                    :class="{'grayscale' : !option.stock}"
                    :alt="option.description"
                    :src="getOptionImage(option, false)"
                />
                <div v-if="showStockWarningLabels && option.stockRemainingLabel" class="label-container">
                    <div class="label-out-of-stock alert"> {{ option.stockRemainingLabel }} </div>

                </div>
                <div v-if="option.stock" class="item-description" >
                    {{ option.description }}
                </div>
                <template v-else>
                    <div class="label-container">
                        <span class="label-out-of-stock">{{ optionLabel(option)}}</span>
                    </div>
                    <div class="item-description">
                        {{ option.description }}
                    </div>
                </template>
            </div>
        </div>
        <hr v-show="noSelActive" class="no-sel-border">
    </div>
</template>

<script>
import {store} from '@/store/productPage';
import {isEmpty} from 'lodash-es';

import browser from '@/Utilities/browser';
import utilities from '@/Utilities/common';
import {storePdp} from '@/store/product-page';

export default {
    storePdp,
    name: 'OptionSlide',
    components: {},
    props: {
        id: {
            type: String,
            default: 'carouselPicker',
        },
        label: String,
        options: Array,
        optionType: String,
        value: Object,
        selectionType: {
            type: String,
            default: 'primary',
        },
        defaultValue: {
            type: Object,
            default: null,
        },
        itemIndex: { // for multiple widgets
            type: Number,
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        emptySelectionWarning: {
            type: Boolean,
            default: false,
        },
        showStockWarningLabels: { // ex: in case of primary and secondary options (hides in primary -> can confuse the client)
            type: Boolean,
            default: true,
        }
    },
    data: function() {
        return {
            carouselElem: null,
            selectedElement: null,
            optionsLength: 0,
            isFirstSelected: false,
            isLastSelected: false,
        };
    },
    computed: {
        kStrings() {
            return storePdp.getters.kStrings;
        },
        noSelActive() {
            return !this.defaultValue && this.emptySelectionWarning;
        },
        carouselCenter() {
            this.$nextTick(() => {
                return this.carouselElem.getBoundingClientRect().width / 2;
            });
            return this.carouselElem.getBoundingClientRect().width / 2;
        },
        showControls() {
            return this.options.length > 4;
        },
        isSafari() {
            return browser.isSafari();
        },
    },
    methods: {
        scrollToSelected(resetToVar = null, resetDefault = false, smooth = true) {
            if (this.value || resetToVar) {
                let defaultSelected = !resetToVar ? this.$refs.carouselItems.find(
                    element => element.dataset.id == this.value.id) : this.$refs.carouselItems.find(
                    element => element.dataset.id == resetToVar);
                if (resetDefault && !isEmpty(this.$refs.carouselItems.find(element => element.dataset.isdefaultsku))) {
                    defaultSelected = this.$refs.carouselItems.find(element => element.dataset.isdefaultsku);
                }

                if (defaultSelected) {
                    this.carouselElem.scrollTo({
                        top: 0,
                        left: defaultSelected.offsetLeft - (defaultSelected.offsetWidth / 2) - (this.carouselCenter / 3),
                        behavior: smooth ? 'smooth' : 'instant',
                    });
                    this.selectedElement = defaultSelected;
                    this.isFirstSelected = defaultSelected.dataset.order == 0;
                    this.isLastSelected = defaultSelected.dataset.order == this.optionsLength - 1;
                }
            }
        },

        updateOption(option) {
            this.$emit('input', option);
            this.$emit('update-current-option', this.selectionType, option);
            this.scrollToSelected(option.id);
        },

        controlDir(dir = 1) {
            // 1st design revision, scrolls left / right (+/- 2 items), no selection
            if (dir == 1) { // right
                // its 4 now...
                this.carouselElem.scrollBy({top: 0, left: this.carouselCenter * 1.5, behavior: 'smooth'});
            } else { // left
                this.carouselElem.scrollBy({top: 0, left: -this.carouselCenter * 1.5, behavior: 'smooth'});
            }

            let osTimer = 225;
            if (this.isSafari) {
                osTimer = 300;
            }

            setTimeout(() => {
                if (this.selectedElement) {
                    this.isFirstSelected = this.selectedElement.dataset.order == 0 && utilities.isElementInViewport(this.carouselElem, this.selectedElement);
                    this.isLastSelected = (this.selectedElement.dataset.order == this.optionsLength - 1) && utilities.isElementInViewport(this.carouselElem, this.selectedElement);
                }
            }, osTimer);
        },

        getOptionImage: function(option, placeholder) {
            //let fallBackImgUrl = 'https://via.placeholder.com/150';
            let fallBackImgUrl = '/themes/prozis-mobile2/imgs/img-placeholder.jpg';

            let optionType = this.optionType;
            let nwOption = optionType == 'optionId' ? option.images.filter(img => img.imageStatus == 'NW') : null;

            if (option.images.length && optionType && option.images.length >= 5) {
                // fallback legacy <5
                switch (optionType) {
                    case 'optionId':
                        // @Danieu review
                        // aqui o ?? dava jeito
                        return !placeholder ? (!isEmpty(nwOption) ? nwOption[0].image : (!isEmpty(option.images[3])
                                ? option.images[3].image
                                : fallBackImgUrl))
                            : (!isEmpty(nwOption) ? nwOption[0].placeholderImage : (!isEmpty(option.images[3])
                                ? option.images[3].placeholderImage
                                : fallBackImgUrl));

                    default:
                        return !placeholder
                            ? !isEmpty(option.images)
                                ? option.images[1].image
                                : fallBackImgUrl
                            : option.images[1].placeholderImage
                                ? option.images[1].placeholderImage
                                : fallBackImgUrl;
                }
            } else {
                return fallBackImgUrl;
            }
            //return null;
        },
        optionLabel(option){
            if(option.displayType == 'LAYOUT_PROMOTER_NOT_ELIGIBLE'){
                return this.kStrings.KNOT_ELIGIBLE;
            }
            return this.kStrings.kPROD_STOCK_OUT;
        }
    },
  watch: {
      value(val) {
          if(val && val.pointsPurchaseData) {
              storePdp.dispatch('pdpDesktop/addToCartDesktop/updateFloatBtn', {pointsBtn: {
                  disabled: val.pointsPurchaseData.disableButton,
                  hide: val.pointsPurchaseData.hide,
                  label: val.pointsPurchaseData.btnLabel,
                  noticeLabel: val.pointsPurchaseData.noticeLabel,
                  modalDescription: val.pointsPurchaseData.modalDescription,
                  availablePoints: val.pointsPurchaseData.availablePoints,
                  mode: '',
                  loadingBar: 0,
                }});
          } else {
              storePdp.dispatch('pdpDesktop/addToCartDesktop/updateFloatBtn', {pointsBtn: null });
          }
      }
  },
    created() {
        this.$emit('input', this.value);
        if(this.value && this.value.pointsPurchaseData) {
            storePdp.dispatch('pdpDesktop/addToCartDesktop/updateFloatBtn', {pointsBtn: {
                  disabled: this.value.pointsPurchaseData.disableButton,
                  hide: this.value.pointsPurchaseData.hide,
                  label: this.value.pointsPurchaseData.btnLabel,
                  noticeLabel: this.value.pointsPurchaseData.noticeLabel,
                  modalDescription: this.value.pointsPurchaseData.modalDescription,
                  availablePoints: this.value.pointsPurchaseData.availablePoints,
                  mode: '',
                  loadingBar: 0,
              }});
        }
    },
    mounted() {
        this.carouselElem = this.$refs.carouselPicker;
        this.optionsLength = this.options.length;
        if(this.defaultValue) {
            this.scrollToSelected(this.defaultValue.id, false, false);
        } else if(this.optionsLength == 1) {
            this.updateOption(this.options[0]);
        }

        //console.log(this.itemIndex  + ' -> MOUNTED options: ', this.options);
    },
};
</script>

<style lang="scss">
@import "../styles/optionSlide";
</style>